// extracted by mini-css-extract-plugin
module.exports = {"body":"PageWithHeaderAndFooter_body__TK0xJ","container":"PageWithHeaderAndFooter_container__GxSRe"};